import { render, staticRenderFns } from "./TaskConfirmationModal.vue?vue&type=template&id=7d7b2379&scoped=true&"
import script from "./TaskConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./TaskConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./TaskConfirmationModal.vue?vue&type=style&index=0&id=7d7b2379&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7b2379",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardActions,VCardText,VIcon})
